import { render, staticRenderFns } from "./MobileOrderCard.vue?vue&type=template&id=212bf400&scoped=true"
import script from "./MobileOrderCard.vue?vue&type=script&lang=js"
export * from "./MobileOrderCard.vue?vue&type=script&lang=js"
import style0 from "./MobileOrderCard.vue?vue&type=style&index=0&id=212bf400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212bf400",
  null
  
)

export default component.exports